import { render, staticRenderFns } from "./SupportMessages.vue?vue&type=template&id=2897271f"
import script from "./SupportMessages.vue?vue&type=script&lang=js"
export * from "./SupportMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports